export default __webpack_public_path__ + "static/media/hero-goldman.597718d9.webp";